module.exports = __webpack_public_path__ + "static/media/S-3-Y.6f0f5987.mp3";